import allItems from './items';
import allHeaders from './headers';

export default { ...allItems, ...allHeaders };
